document.addEventListener("DOMContentLoaded", function () {
  "use strict";
  // Class constructor for Komodo Toggle component.
  // Implements Komodo component design pattern
  //
  // @constructor
  // @param {HTMLElement} The element that will be upgraded to be Komodo Toggle.
  var KomodoToggle = function KomodoToggle(element) {
    this.element_ = element;
    KomodoToggle._instances = KomodoToggle._instances || [];
    KomodoToggle._instances.push(this);

    // Ensure non-native toggle affordances are keyboard reachable.
    // Many templates use <span>/<svg>/<img> as the toggle target.
    var tagName = (this.element_.tagName || '').toUpperCase();
    var isNativeInteractive = tagName === 'A' || tagName === 'BUTTON' || tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA';
    var closestInteractive = this.element_.closest ? this.element_.closest('a,button') : null;
    var isNestedInInteractive = !!closestInteractive && closestInteractive !== this.element_;

    if (!isNativeInteractive && !isNestedInInteractive) {
      if (!this.element_.hasAttribute('tabindex')) {
        this.element_.setAttribute('tabindex', '0');
      }
      if (!this.element_.hasAttribute('role')) {
        this.element_.setAttribute('role', 'button');
      }
    }

    var selectors = this.element_.getAttribute("data-toggle").split(",");
    this.components = [];
    for (var i = 0; i < selectors.length; i++) {
      var component = document.querySelector(selectors[i]);
      if (component) {
        this.components.push(component);
      }
    }
    this.dynamicClassList = this.element_
      .getAttribute("data-toggle-classes")
      .split(",");
    // Toggle Accordion
    if (!this.element_.disabled && this.components.length > 0) {
      // check if this check should be object type
      this.element_.addEventListener("click", this.toggleComponent.bind(this));

      // Keyboard support: Space should activate button-like toggles, and also
      // activate anchors that use javascript:void(0) patterns.
      this.element_.addEventListener(
        'keydown',
        function (event) {
          if (!event) {
            return;
          }
          var keyCode = event.keyCode || event.which;
          if (keyCode !== 13 && keyCode !== 32) {
            return;
          }

          // Prevent scrolling on Space and avoid duplicate activation.
          if (keyCode === 32) {
            event.preventDefault();
            this.element_.click();
            return;
          }

          // Enter already triggers click for native controls (e.g., <a>, <button>).
          if (!isNativeInteractive) {
            event.preventDefault();
            this.element_.click();
          }
        }.bind(this)
      );
    }
  };

  const navElement = document.getElementById("mega-nav");
  const navContainer = document.getElementById("nav-container");
  const notificationContainer = document.getElementById("notification-dd");
  let navInstanciated = false;
  let previousMenuItem = null;


  window["KomodoToggle"] = KomodoToggle;
  // Store strings for class names defined by this component that are used in
  // Javascript. This allows us to simply change it in one place should we decide
  // to modify at a later date.
  //
  // @enum {string}
  // @private
  KomodoToggle.prototype.cssClasses_ = {
    component: "komodo-toggle-component",
  };
  // Toggle Component.
  //
  // @public
  KomodoToggle.prototype.toggleComponent = function (event) {
    // Treat clicks on nested DOM (e.g., <svg><path>) as valid activations.
    // Use currentTarget to avoid relying on the deepest target element.
    var triggerEl = event && event.currentTarget ? event.currentTarget : this.element_;
    var clickedInsideTrigger = !!(event && event.target && triggerEl && triggerEl.contains && triggerEl.contains(event.target));

    // Prevent default navigation for anchor-based toggle triggers
    if (triggerEl && triggerEl.tagName === 'A') {
      event.preventDefault();
    }

    // Note: Master branch had event.stopPropagation() here, but it's no longer needed
    // because the auto-focus fix (only focusing on keyboard events) solved the Safari
    // issue where clicks were being misattributed to full-bg overlay.

    // If a descendant KomodoToggle already handled this same DOM event,
    // don't toggle again on ancestors (prevents double-toggle), but still
    // allow the event to bubble so other open menus can close via document click.
    if (event && event.__komodoToggleHandled) {
      return;
    }

    // Clear any stale document click handler from prior open cycles.
    // Without this, keyboard-triggered clicks can be immediately cancelled
    // by an older handler that never got a chance to self-remove.
    if (this._documentClickHandler) {
      document.removeEventListener("click", this._documentClickHandler);
      this._documentClickHandler = null;
    }

    var callback = function (evt) {
      // Check to see if the document is processing the same event that
      // displayed the menu in the first place. If so, do nothing.
      // Also check to see if the menu is in the process of closing itself, and
      // do nothing in that case.
      // Also check if the clicked element is a menu item
      // if so, do nothing.

      if (
        evt !== event &&
        this.components.indexOf(
          evt.target.closest("." + this.cssClasses_.component)
        ) == -1
      ) {
        document.removeEventListener("click", callback);
        if (this._documentClickHandler === callback) {
          this._documentClickHandler = null;
        }

        const el = evt.target;
        const navContainerOpen = navContainer ? (navContainer.classList.contains("open")) : false;
        const isClickOnNav = navElement ? (el.id === navElement.id) : false;
        const isClickOutsideNavContainer = navContainer ? (!navContainer.contains(el)) : true;
        const isLinkClick = el.tagName === "A";
        const isClose = el.classList.contains("close");
        const isMenuItem = el.tagName === "LI"; // may need to make this stronger
        const isSamePreviousMenuItem = previousMenuItem === el;
        const isOpen = el.classList.contains("open");
        const shouldCloseNav =
          isSamePreviousMenuItem &&
          isMenuItem &&
          navContainerOpen && isOpen;


        if (
          navElement &&
          (isClickOutsideNavContainer ||
          isLinkClick ||
          isClose ||
          (isClickOnNav && navContainerOpen))
        ) {
          navElement.classList.remove("open");
        }

        let isNotificationReload = false;
        if (notificationContainer) {
          for (var i = 0; i < this.components.length; i++) {
            const currentElement = this.components[i];
            if (currentElement.id === notificationContainer.id && currentElement.innerHTML.includes("c-loader")) {
              isNotificationReload = true;
              break;
            }
          }
        }
        for (var i = 0; i < this.components.length; i++) {
          const currentEl = this.components[i];
          const isNav = navElement ? (currentEl.id === navElement.id) : false;
          const shouldClose =
            !navContainerOpen &&
            currentEl === el &&
            !currentEl.classList.contains("open");



          // skip nav toggle
          if (!isNav && !shouldCloseNav && !isNotificationReload) {
            this.components[i].dispatchEvent(
              componentHandler.createEvent(
                "hide.komodo.toggle",
                null,
                false,
                true
              )
            );

            this.components[i].classList.remove(this.dynamicClassList);

            this.components[i].dispatchEvent(
              componentHandler.createEvent(
                "hidden.komodo.toggle",
                null,
                false,
                true
              )
            );
          }
        }

        if (KomodoToggle._lastOpened === this) {
          KomodoToggle._lastOpened = null;
        }



        if (isMenuItem && previousMenuItem !== evt.target) {
          previousMenuItem = evt.target;
        }
      }
    }.bind(this);

    // Store so we can reliably remove it on close/toggle.
    this._documentClickHandler = callback;

    if (clickedInsideTrigger) {
      if (event) {
        event.__komodoToggleHandled = true;
      }
      const el = triggerEl;
      const isMenuItem = el.tagName === "LI"; // may need to make this stronger

      var focusFirstTabbableInDialog = function (dialogEl, attemptsLeft) {
        if (!dialogEl) {
          return;
        }

        // Wait for the dialog to actually be open/painted.
        var isOpen = dialogEl.classList && dialogEl.classList.contains('open');
        var isVisible = !!(dialogEl.getClientRects && dialogEl.getClientRects().length);
        if (!isOpen || !isVisible) {
          if (attemptsLeft > 0) {
            window.setTimeout(function () {
              focusFirstTabbableInDialog(dialogEl, attemptsLeft - 1);
            }, 50);
          }
          return;
        }

        var focusableSelector = [
          'a[href]:not([tabindex="-1"])',
          'button:not([disabled]):not([tabindex="-1"])',
          'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
          'select:not([disabled]):not([tabindex="-1"])',
          'textarea:not([disabled]):not([tabindex="-1"])',
          '[tabindex]:not([tabindex="-1"])'
        ].join(',');

        var focusables = dialogEl.querySelectorAll ? dialogEl.querySelectorAll(focusableSelector) : [];
        for (var f = 0; f < focusables.length; f++) {
          var candidate = focusables[f];
          if (!candidate) {
            continue;
          }
          // Skip elements that are not actually visible.
          if (candidate.getClientRects && candidate.getClientRects().length === 0) {
            continue;
          }
          try {
            candidate.focus();
            return;
          } catch (e) {
            // try next
          }
        }

        // Fallback: focus the dialog itself for screen readers.
        if (!dialogEl.hasAttribute('tabindex')) {
          dialogEl.setAttribute('tabindex', '-1');
        }
        try {
          dialogEl.focus();
        } catch (e) {
          // noop
        }
      };

      // If we're opening a menu, close any other open Komodo toggle containers first.
      // This prevents shared overlays (e.g., #full-bg) from being toggled off when
      // switching between menus like Promo -> Account.
      var isOpening = !this.components[0].classList.contains(this.dynamicClassList);
      if (isOpening) {
        var openContainers = document.querySelectorAll('.komodo-toggle-component.open');
        for (var c = 0; c < openContainers.length; c++) {
          var openContainer = openContainers[c];
          var isThisToggleTarget = this.components.indexOf(openContainer) !== -1;
          var isNav = navElement ? (openContainer.id === navElement.id) : false;
          if (!isThisToggleTarget && !isNav) {
            openContainer.dispatchEvent(
              componentHandler.createEvent('hide.komodo.toggle', null, false, true)
            );
            openContainer.classList.remove(this.dynamicClassList);
            openContainer.dispatchEvent(
              componentHandler.createEvent('hidden.komodo.toggle', null, false, true)
            );
          }
        }
      }

      if (this.components[0].classList.contains(this.dynamicClassList)) {
        this.element_.dispatchEvent(
          componentHandler.createEvent("hide.komodo.toggle", null, false, true)
        );
      } else {
        this.element_.dispatchEvent(
          componentHandler.createEvent("show.komodo.toggle", null, false, true)
        );
      }
		// w/o using id selectors
		// on 1st click (hamburger-btn) parent is nav container or f.closest('.komodo-toggle-component'), f.closest('.komodo-toggle-component').querySelector('nav') -- nav
        // [...this.components].shift().querySelector('nav') -- finds nav
        // [...this.components].shift() -- nav container



      for (var i = 0; i < this.components.length; i++) {
        const currentEl = this.components[i];
        const isNav = navElement ? (currentEl.id === navElement.id) : false;
        const isChildOfNav = navElement ? (navElement.contains(currentEl) && !isNav) : false;
        const isParentContainer = navContainer ? (currentEl.id === navContainer.id) : false;
        const isSamePreviousMenuItem = previousMenuItem === el && isMenuItem;
        const toggleNavElement = navContainer ? (isNav && ((!isSamePreviousMenuItem && !currentEl.classList.contains("open")) || (isSamePreviousMenuItem && currentEl.classList.length !== navContainer.classList.length))) : false; // when previous is same
        const isClickOutsideNavContainer = navContainer ? (!navContainer.contains(currentEl)) : true;


        // skip nav toggle if child of nav, unless instanciated
        if (
          (isNav && window.innerWidth < 992) || // do not skip nav toggle if request is coming from mobile
          !navInstanciated ||
          isChildOfNav ||
          isParentContainer ||
          isClickOutsideNavContainer ||
          toggleNavElement
        ) {

          this.components[i].classList.toggle(this.dynamicClassList);
          navInstanciated = true;

         }

      }

      // Keep the shared overlay open when opening any menu that includes it.
      if (isOpening) {
        for (var j = 0; j < this.components.length; j++) {
          if (this.components[j] && this.components[j].id === 'full-bg') {
            this.components[j].classList.add(this.dynamicClassList);
          }
        }
      }

      if (this.components[0].classList.contains(this.dynamicClassList)) {
        KomodoToggle._lastOpened = this;
        this.element_.dispatchEvent(
          componentHandler.createEvent("shown.komodo.toggle", null, false, true)
        );

        // Only listen for outside clicks while open.
        document.addEventListener("click", callback);

        // On open, move focus into the opened dialog (Promo/Account/etc.).
        // Prefer the first component with role="dialog".
        // IMPORTANT: delay focus transfer so the same keyboard/touch activation
        // that opened the menu doesn't accidentally activate the newly-focused
        // first <a> link (observed in some browsers/environments).
        // SAFARI FIX: Only auto-focus for keyboard navigation, not mouse clicks.
        // Mouse clicks in Safari get confused when we programmatically focus elements.
        var shouldAutoFocus = event && (
          event.detail === 0 || // Keyboard-initiated clicks have detail=0
          event.type === 'keydown' ||
          event.type === 'keypress'
        );

        if (shouldAutoFocus) {
          var focusDelayMs = 150; // Use longer delay for keyboard
          window.setTimeout(
            function () {
              for (var k = 0; k < this.components.length; k++) {
                var componentEl = this.components[k];
                if (!componentEl || componentEl.id === 'full-bg') {
                  continue;
                }
                if (componentEl.getAttribute && componentEl.getAttribute('role') === 'dialog') {
                  focusFirstTabbableInDialog(componentEl, 50);
                  break;
                }
              }
            }.bind(this),
            focusDelayMs
          );
        }
      } else {
        if (KomodoToggle._lastOpened === this) {
          KomodoToggle._lastOpened = null;
        }
        this.element_.dispatchEvent(
          componentHandler.createEvent(
            "hidden.komodo.toggle",
            null,
            false,
            true
          )
        );

        // Closed: ensure we don't leave an outside-click handler hanging around.
        document.removeEventListener("click", callback);
        if (this._documentClickHandler === callback) {
          this._documentClickHandler = null;
        }
      }

    }
  };

  KomodoToggle.prototype["toggleComponent"] =
    KomodoToggle.prototype.toggleComponent;

  KomodoToggle.prototype.isOpen = function () {
    if (!this.components || !this.components.length) {
      return false;
    }

    var primaryClass = (this.dynamicClassList && this.dynamicClassList[0]) || "open";

    for (var i = 0; i < this.components.length; i++) {
      var component = this.components[i];
      if (component && component.classList && component.classList.contains(primaryClass)) {
        return true;
      }
    }

    return false;
  };

  KomodoToggle.prototype.closeViaEscape = function () {
    if (!this.element_ || !this.isOpen()) {
      return;
    }

    // Toggle the menu on escape key press. This is needed to support keyboard users.
    this.toggleComponent.bind(this)

    if (typeof this.element_.focus === 'function') {
      // Return focus to the toggle trigger so keyboard users regain context.
      try {
        this.element_.focus();
      } catch (e) {
        // noop: some legacy elements throw if they cannot be focused.
      }
    }
  };

  KomodoToggle.closeAllOpen = function () {
    var lastOpen = KomodoToggle._lastOpened;
    if (lastOpen && typeof lastOpen.closeViaEscape === "function") {
      lastOpen.closeViaEscape();
      return;
    }

    if (!KomodoToggle._instances) {
      return;
    }

    for (var i = KomodoToggle._instances.length - 1; i >= 0; i--) {
      var instance = KomodoToggle._instances[i];
      if (instance && typeof instance.isOpen === "function" && instance.isOpen()) {
        if (typeof instance.closeViaEscape === "function") {
          instance.closeViaEscape();
        }
        return;
      }
    }
  };

  // The component registers itself. It can assume componentHandler is available
  // in the global scape.
  componentHandler.register({
    constructor: KomodoToggle,
    classAsString: "KomodoToggle",
    cssClass: "komodo-toggle",
    widget: true,
  });

  document.addEventListener("keydown", function (event) {
    var key = event.key || event.keyCode;
    if (key === "Escape" || key === "Esc" || key === 27) {
      KomodoToggle.closeAllOpen();
    }
  });
});